module.exports = __webpack_public_path__ + "img/Toshikazu-Chujo.d94ce50b.jpg";